/*
 * File: EllipsesText.tsx
 * Project: mdsi-template-app
 * -----
 * Last Modified: 02 Mar 2021 2:26:29 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Tooltip, Typography } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import { FC, useEffect, useState } from 'react';

const styles: InlineStylesModel = {
  typographyContainer: {
    maxWidth: '100%'
  },
  typography: {
    width: '100%',
    marginBottom: 0
  }
};

interface EllipsesTextProps {
  text: string;
  tooltipCharacterCount: number;
  color?: string;
}

const EllipsesText: FC<EllipsesTextProps> = ({ text, tooltipCharacterCount, color }: EllipsesTextProps) => {
  const [ellipis, setEllipses] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  const onParagraphHover = (): void => {
    if (ellipis) setIsVisible(true);
  };

  const onParagraphExit = (): void => {
    if (ellipis) setIsVisible(false);
  };

  useEffect(() => {
    if (text?.length > tooltipCharacterCount && !ellipis) {
      setEllipses(true);
    }
  }, [tooltipCharacterCount, ellipis, text]);

  return (
    <Tooltip placement="topLeft" title={text} open={isVisible}>
      <div onMouseEnter={onParagraphHover} onMouseLeave={onParagraphExit} style={styles.typographyContainer}>
        <Typography.Paragraph ellipsis style={color ? { width: '100%', marginBottom: 0, color: color } : styles.typography}>
          {text?.length ? text : 'N/A'}
        </Typography.Paragraph>
      </div>
    </Tooltip>
  );
};

export default EllipsesText;
